// conditional

import { Scene } from "three/src/scenes/Scene";
import { MSDFTextGeometry, MSDFTextMaterial, uniforms } from "three-msdf-text";
import * as THREE from "three";
import gsap from "gsap";
import fragment from "./selected-shader/fragment.glsl";
import vertex from "./selected-shader/vertex.glsl";

import fnt from "../../fonts/Poppins-Light-msdf.json";
import atlasURL from "../../fonts/Poppins-Light.png";

import { InteractionManager } from "three.interactive";
const createInputEvents = require("simple-input-events");

function lerp(a, b, n) {
  return (1 - n) * a + n * b;
}
function r(a, b) {
  return lerp(a, b, Math.random());
}

export default class Selected extends Scene {
  constructor(parent) {
    super();
    this.mobilescale = window.isMobile?0.5:1
    this.globalcanvas = parent;
    this.event = createInputEvents(this.globalcanvas.container);
    this.eventWindow = createInputEvents(window);
    this.time = 0;
    this.interactive = []
    this.speed = 0;
    this.progress = 0;
    this.lastProgress = 0;
    this.targetSpeed = 0;
    this.width = window.innerWidth;
    this.height = window.innerHeight;
    this.needsRender = false;
    this.raycaster = new THREE.Raycaster();
    this.mouse = new THREE.Vector2();

    this.camera = new THREE.PerspectiveCamera(
      70,
      this.width / this.height,
      0.01,
      1000
    );
    this.camera.position.set(0, 0, 2);

    // this.interactionManager = new InteractionManager(
    //   this.globalcanvas.renderer,
    //   this.camera,
    //   document.body
    // );
    // this.addObjects();
    if(document.querySelector('.selected')) this.events();
    this.updateScene();
    this.addImages();

    
  }

  select(mesh,uv){

    if(mesh){
      mesh.material.uniforms.uHover.value = uv;
      gsap.to(mesh.userData.textmeshopacity,{
        value: 1,
        duration: 0.3
      })

      gsap.to(mesh.material.uniforms.uHoverState,{
        value: 1,
        duration: 0.3
      })


      document.getElementsByTagName("body")[0].style.cursor = "pointer";
    } else{
      this.interactive.forEach((item) => {
        gsap.to(item.userData.textmeshopacity,{
          value: 0,
          duration: 0.3
        })
        gsap.to(item.material.uniforms.uHoverState,{
          value: 0,
          duration: 0.3
        })
      })

      document.getElementsByTagName("body")[0].style.cursor = "default";
    }
    
  }

  events() {
    let distance = 100;
    this.event.on("move", ({ uv }) => {
      this.mouse.x = (uv[0]) *2 -1;
      this.mouse.y = -(uv[1]) * 2 +1;
      
      this.raycaster.setFromCamera(this.mouse, this.camera);

      let intersects = this.raycaster.intersectObjects(this.interactive);
      // console.log(intersects,'INTERSECTS')
      if (intersects.length > 0) {
        this.select(intersects[0].object,intersects[0].uv,true);
      } else {
        this.select(null);
      }


    });

    this.eventWindow.on("down", ({ uv }) => {
      this.mouse.x = (uv[0]) *2 -1;
      this.mouse.y = -(uv[1]) * 2 +1;
      this.raycaster.setFromCamera(this.mouse, this.camera);
      
      let intersects = this.raycaster.intersectObjects(this.interactive);
      if (intersects.length > 0) {
        window.location = intersects[0].object.userData.url;
      } 
    })
    // setTimeout(() => {
      this.animation = gsap
        .timeline({
          onUpdate: (args) => {
            this.progress = this.animation.progress();
            // this.updateScene();
            // console.log("PLAY NEW SELECTED");
            // console.log(this.progress)

            // if(!this.play) {
            //     this.play = true;this.render();
            // } else{
            //     this.play = false;
            // }
          },
          scrollTrigger: {
            scroller: ".scrollContainer",
            scrub: true,
            trigger: ".selected",
            pin: true,
            anticipatePin: 1,
            refreshPriority: 500,
            onEnterBack: () => {
              //   if (!this.play) this.play = true;
              //   this.render();
              this.needsRender = true;
            },
            onEnter: () => {
              //   if (!this.play) this.play = true;
              //   this.render();
              this.needsRender = true;
            },
            onLeave: () => {
              //   this.play = false;
              //   console.warn("LEAVE SELECTED");
              this.needsRender = false;
            },
            onLeaveBack: () => {
              //   this.play = false;
              this.needsRender = false;
            },
            onUpdate: (args) => {
              //   console.log("UPDATE SELECTED", args.progress);
              // this.progress = args.progress;
              // this.update()
            },
            start: "top top",
            //   end: pinWrapWidth
            end: "bottom bottom-=" + 2 * this.height + "px",
          },
        })
        .fromTo(
          ".selected__title span:nth-child(1)",
          {
            x: distance,
          },
          {
            x: -distance,
            ease: "power2.inOut",
          }
        )
        .fromTo(
          ".selected__title span:nth-child(2)",
          {
            x: -distance,
          },
          {
            x: distance,
            ease: "power2.inOut",
          },
          0
        );
    // }, 0);
  }

  addImages() {
    if(!document.querySelector(".selected__images")) return;
    let images = document.querySelector(".selected__images");
    images = [...images.querySelectorAll("img")];
    //   let triggers = [...document.querySelectorAll('.js-trigger')];
    this.meshes = [];
    this.materials = [];

    this.material = new THREE.ShaderMaterial({
      side: THREE.DoubleSide,
      uniforms: {
        distortion: { value: 0 },
        time: { value: 0 },
        uHover: { value: new THREE.Vector2(0,0) },
        uHoverState: { value: 0 },
        uTexture: { value: null },
      },
      // wireframe: true,
      // transparent: true,
      vertexShader: vertex,
      fragmentShader: fragment,
    });

    //   Promise.all([
    //     loadFontAtlas("./fonts/roboto/roboto-regular.png"),
    // ]).then(([atlas, font]) => {
    //     const geometry = new MSDFTextGeometry({
    //         text: "Hello World",
    //         font: font.data,
    //     });

    //     const material = new MSDFTextMaterial();
    //     material.uniforms.uMap.value = atlas;

    //     const mesh = new THREE.Mesh(geometry, material);
    // });

    function loadFontAtlas(path) {
      const promise = new Promise((resolve, reject) => {
        const loader = new THREE.TextureLoader();
        loader.load(path, resolve);
      });

      return promise;
    }

    let imagesPromises = images.map((image) => {
      return new Promise((resolve, reject) => {
        const loader = new THREE.TextureLoader();
        let url = image.parentNode.href
        loader.load(image.src, (texture) => {
          resolve({ image, texture, url });
        });
      });
    });

    // imagesPromises.push(loadFontAtlas(atlasURL));

    Promise.all([Promise.all(imagesPromises), loadFontAtlas(atlasURL)]).then(
      ([images, atlas]) => {
        // console.warn(fnt,images);
        images.forEach((o, i) => {
          //   new THREE.TextureLoader().load(img.src, (texture) => {
          let text = "PROJECT NAME LOREM";
          const textmaterial = new MSDFTextMaterial({
            side: THREE.DoubleSide,
              uniforms: {
                // Common
                uOpacity: { value: 0 },
                uColor: { value: new THREE.Color("#ffffff") },
                uMap: { value: null },
                // Rendering
                uThreshold: { value: 0.05 },
                uAlphaTest: { value: 0.01 },
                // Strokes
                uStrokeColor: { value: new THREE.Color("#ff0000") },
                uStrokeOutsetWidth: { value: 0.0 },
                uStrokeInsetWidth: { value: 0.3 },
            }
          });
          textmaterial.uniforms.uMap.value = atlas;
          const textgeometry = new MSDFTextGeometry({
              text:text,
              font: fnt,
          });
          const textmesh = new THREE.Mesh(textgeometry, textmaterial);
          let s = 0.001;
          textmesh.scale.set(s, -s, s);
          let img = o.image;
          let left = parseFloat(img.getAttribute("data-left"));
          let top = parseFloat(img.getAttribute("data-top"));
          let width = parseFloat(img.getAttribute("data-width")) || 1;
          // console.log(theta,which,i)
          // let material = new THREE.MeshBasicMaterial({
          //   map: o.texture,
          //   transparent: true,
          //   opacity: 1,
          //   side: THREE.DoubleSide,
          // });
          let material = this.material.clone();
          this.materials.push(material);
          material.uniforms.uTexture.value = o.texture;
          let aspect =
            o.texture.source.data.width / o.texture.source.data.height;
            let ww = width * 0.7 * aspect *Math.max(this.mobilescale,0.8)
            let hh = width * 0.7 *Math.max(this.mobilescale,0.8)
          let geometry = new THREE.PlaneGeometry(
            ww,
            hh,
            20,
            20
          );
          let mesh = new THREE.Mesh(geometry, material);
          console.log(mesh);
          let group = new THREE.Group();
          mesh.position.x = left*this.mobilescale;
          mesh.position.y = top;
          this.interactive.push(mesh)
          mesh.userData.textmeshopacity = textmesh.material.uniforms.uOpacity;
          mesh.userData.url = o.url;
          // mesh.addEventListener("mousedown", (event) => {
            
          // });

          // mesh.addEventListener("mouseover", (event) => {
          //   console.log('over')
          // });

          // mesh.addEventListener("mouseout", (event) => {
          //   console.log('out')
          // });


          // this.interactionManager.add(mesh);

          textmesh.position.x = left - ww/2;
          textmesh.position.y = top - hh/2 -0.1;
          console.log(
            mesh.position.y,
            mesh.position.x,
            "xx",
            "ASPECT===",
            left
          );
          //   mesh.position.z = .5
          this.meshes.push({
            group,
            mesh,
            textmaterial,
            x: left,
            y: top,
          });
          //   group.add(mesh)
          //   this.scene.add(group)
          this.add(mesh);
          this.add(textmesh);
          //   let dur = 1;
          //   triggers[i].addEventListener('mouseenter',()=>{
          //       gsap.to(mesh.material,{opacity:1,duration:dur})
          //       gsap.to(mesh.scale,{x:2,y:2,duration:dur,ease:'power3.out'})
          //       gsap.to(this,{speed:0,duration:dur})
          //   })
          //   triggers[i].addEventListener('mouseleave',()=>{
          //       gsap.to(mesh.material,{opacity:0.3,duration:dur})
          //       gsap.to(mesh.scale,{x:1,y:1,duration:dur,ease:'power3.inOut'})
          //       gsap.to(this,{speed:1,duration:dur})
          //   })
          //   });
        });

        this.globalcanvas.renderer.render(this, this.camera);
      }
    );
  }

  resize(w, h) {
    this.camera.aspect = w / h;
    this.camera.updateProjectionMatrix();
    this.vh =
      2 * this.camera.position.z * Math.tan((this.camera.fov * Math.PI) / 360);
  }

  updateScene() {
    this.time += 0.05;
    this.speed += this.progress - this.lastProgress;
    // console.log(this.speed,'RENDER SELECTED NOW')
    this.targetSpeed += (this.speed - this.targetSpeed) * 0.1;
    if (this.materials) {
      this.materials.forEach((material) => {
        material.uniforms.distortion.value = 3 * this.targetSpeed;
        material.uniforms.time.value = this.time;
      });
    }

    this.speed *= 0.9;
    this.lastProgress = this.progress;

    this.position.y = -this.vh + 2 * this.vh * this.progress;
    // this.position.y = 0
    // this.interactionManager.update();
  }
}
